import moment from 'moment';

const DATE = new Date();
const formatHour = (hour) => moment(hour, 'HHmmss').format('HH:mm:ss');
const formatDate = (date) => moment(date).format('YYYY-MM-DD');
const buildDateAndHour = ({ date = moment(DATE).format('YYYY-MM-DD'), hour = moment(DATE).format('HHmmss'), }) => {
    if (!date) {
        date = new Date(moment(DATE).format('YYYY-MM-DD'));
    }
    if (!hour) {
        hour = new Date(moment(DATE).format('HHmmss'));
    }
    return new Date(`${formatDate(date)}T${formatHour(hour)}`);
};
const formatLocaleDate = (date, format) => {
    return moment(date)
        .locale('pt-br')
        .format(format); // https://momentjs.com/docs/#/displaying/format/
};

export { buildDateAndHour, formatDate, formatHour, formatLocaleDate };
